import _ from 'lodash';
import React from 'react';
import classNames from 'classnames';

import {formatDate} from 'utils/datetime';

import Table from 'components/Table';
import Button from 'components/Button';
import RenewalIcon from 'components/RenewalIcon';
import BookingStatusTag from 'components/BookingStatusTag';
import {PartialTenantInfo} from 'components/TenantInfo';
import RoomWithRoomType from 'components/RoomWithRoomType';

import './styles.css';

interface BookingProps {
  id: number;
  primaryTenant: {
    fullName: string;
    email: string;
    initials: string;
    avatarCropped: string | undefined;
    internalAvatarCropped: string | undefined;
  };
  room: {
    roomNumber?: string;
    roomType?: string;
  };
  bookingType: string;
  startDate: string;
  endDate: string;
  status: string;
  createdAt: string;
  createdBy: {
    fullName: string;
  };
  cancelled: boolean;
  source: string;
  isRenewal: boolean;
}

interface BookingsTableProps {
  bookings: Array<BookingProps>;
  openCreateBookingModal: React.MouseEventHandler;
  redirectToBookingDetail: ({bookingId}: {bookingId: number}) => void;
}

class BookingsTable extends React.Component<BookingsTableProps> {
  render() {
    const {
      bookings,
      openCreateBookingModal,
      redirectToBookingDetail
    } = this.props;

    return (
      <div className="BookingsTable">
        <Table>
          <Table.Header>
            <Table.HeaderItem heading="Booking" className="booking" />
            <Table.HeaderItem heading="Room No" className="room" />
            <Table.HeaderItem heading="Type" className="type" />
            <Table.HeaderItem heading="Arrival" className="arrival" />
            <Table.HeaderItem heading="Departure" className="departure" />
            <Table.HeaderItem heading="Status" className="status" />
            <Table.HeaderItem heading="Created" className="createdAt" />
            <Table.HeaderItem heading="Created by" className="createdBy" />
          </Table.Header>
          <Table.Body>
            {bookings &&
              bookings.map((booking, index) => (
                <Table.Row
                  className={classNames({cancelled: booking.cancelled})}
                  key={index}
                  onClick={() =>
                    redirectToBookingDetail({bookingId: booking.id})
                  }>
                  <Table.Cell>
                    <div className="colab-centered-v">
                      <PartialTenantInfo tenant={booking.primaryTenant} />
                      {booking.isRenewal && <RenewalIcon />}
                    </div>
                  </Table.Cell>
                  <Table.Cell>
                    <RoomWithRoomType
                      room={_.get(booking, 'room.roomNumber')}
                      roomType={_.get(booking, 'room.roomType.name')}
                    />
                  </Table.Cell>
                  <Table.Cell>{booking.bookingType}</Table.Cell>
                  <Table.Cell>{formatDate(booking.startDate)}</Table.Cell>
                  <Table.Cell>{formatDate(booking.endDate)}</Table.Cell>
                  <Table.Cell className="status">
                    <BookingStatusTag status={booking.status} />
                  </Table.Cell>
                  <Table.Cell>{formatDate(booking.createdAt)}</Table.Cell>
                  <Table.Cell className="createdBy colab-bold">
                    {_.get(booking.createdBy, 'fullName') || booking.source}
                  </Table.Cell>
                </Table.Row>
              ))}
          </Table.Body>
        </Table>
        <div className="BookingsTable__footer">
          <Button blue onClick={openCreateBookingModal}>
            New Booking
          </Button>
        </div>
      </div>
    );
  }
}

export default BookingsTable;
